import { ScrapeEntryType } from "../../../Types/scrapeEntryType"
import { Form, Formik } from "formik"
import { TextInputField } from "../../FormFields/TextInput/TextInputField"
import { SelectInputField } from "../../FormFields/SelectInput/SelectInputField"
import { DateInputField } from "../../FormFields/DateInput/DateInputField"
import { Button } from "react-bootstrap"
import { useState } from "react"
// import { useSelector } from "react-redux"
// import { accountSelector } from "../../../redux/account/accountSlice"

const generateBlankScrapeEntry = () => ({
    createdDate: new Date(),
    lastScrape: new Date(),
    lastParse: new Date(),
    parsedData: {},
    rawLines: [],
    source: '',
    type: '',
    dataId: '',
    success: false,
    error: false,
    errorMessage: ''
})

export default function ScrapeEntryForm(props: {
    disabled: boolean,
    onSubmit: (v: any) => Promise<any>,
    initialValues?: Partial<ScrapeEntryType>,
}) {
    const {
        disabled,
        onSubmit,
        initialValues,
    } = props

    // const { _id: currentUserId } = useSelector(accountSelector)
    const [rawLinesText, setRawLinesText] = useState(
        initialValues?.rawLines ? initialValues.rawLines.join('\n') : ''
    )
    const [parsedDataText, setParsedDataText] = useState(
        initialValues?.parsedData ? JSON.stringify(initialValues.parsedData, null, 2) : '{}'
    )

    return (
        <div className="scrape-entry-form">
            <Formik
                initialValues={{
                    ...generateBlankScrapeEntry(),
                    ...(initialValues ? initialValues : {}),
                }}
                validate={values => {
                    const errors: any = {};

                    if (!values.source) {
                        errors.source = 'Source is required';
                    }

                    if (!values.type) {
                        errors.type = 'Type is required';
                    }

                    if (!values.dataId) {
                        errors.dataId = 'Data ID is required';
                    }

                    // Validate parsedDataText is valid JSON
                    try {
                        JSON.parse(parsedDataText)
                    } catch (e) {
                        errors.parsedData = 'Parsed Data must be valid JSON'
                    }

                    return errors;
                }}
                onSubmit={async (values, { setSubmitting }) => {
                    if (onSubmit) {
                        try {
                            // Convert rawLines text back to array
                            const rawLinesArray = rawLinesText.split('\n').filter(line => line.trim() !== '')

                            // Convert parsed data text back to object
                            let parsedDataObject = {}
                            try {
                                parsedDataObject = JSON.parse(parsedDataText)
                            } catch (e) {
                                parsedDataObject = {}
                            }

                            onSubmit({
                                ...values,
                                rawLines: rawLinesArray,
                                parsedData: parsedDataObject
                            })
                        } catch (err) {
                            // custom error handler
                        }
                    }
                    setSubmitting(false)
                }}
            >
                {({ values, isSubmitting, errors, touched, setFieldValue, handleChange, setValues }) => {
                    return (
                        <>
                            <Form>
                                <h3>📊 Source Information</h3>
                                <TextInputField
                                    fieldType="text"
                                    fieldLabel="Source"
                                    placeholder="e.g., website.com, api.service.com"
                                    fieldName="source"
                                />

                                <TextInputField
                                    fieldType="text"
                                    fieldLabel="Type"
                                    placeholder="e.g., property-listing, booking-data, user-info"
                                    fieldName="type"
                                />

                                <TextInputField
                                    fieldType="text"
                                    fieldLabel="Data ID"
                                    placeholder="Unique identifier for this data"
                                    fieldName="dataId"
                                />

                                <h3>📅 Timestamps</h3>
                                <DateInputField
                                    fieldLabel="Created Date"
                                    placeholder="Created Date"
                                    fieldName="createdDate"
                                />

                                <DateInputField
                                    fieldLabel="Last Scrape"
                                    placeholder="Last Scrape Date"
                                    fieldName="lastScrape"
                                />

                                <DateInputField
                                    fieldLabel="Last Parse"
                                    placeholder="Last Parse Date"
                                    fieldName="lastParse"
                                />

                                <h3>✅ Status</h3>
                                <SelectInputField
                                    fieldLabel="Success"
                                    placeholder="Select Success Status"
                                    fieldName="success"
                                    options={[
                                        { value: 'true', text: 'Success' },
                                        { value: 'false', text: 'Failed' }
                                    ]}
                                />

                                <SelectInputField
                                    fieldLabel="Has Error"
                                    placeholder="Select Error Status"
                                    fieldName="error"
                                    options={[
                                        { value: 'false', text: 'No Error' },
                                        { value: 'true', text: 'Has Error' }
                                    ]}
                                />

                                <TextInputField
                                    fieldType="textarea"
                                    fieldLabel="Error Message"
                                    placeholder="Error details (if any)"
                                    fieldName="errorMessage"
                                />

                                <h3>📝 Raw Data</h3>
                                <div className="mb-3">
                                    <label className="form-label">Raw Lines</label>
                                    <textarea
                                        className="form-control"
                                        rows={10}
                                        placeholder="Enter raw scraped data (one line per entry)"
                                        value={rawLinesText}
                                        onChange={(e) => setRawLinesText(e.target.value)}
                                        disabled={disabled}
                                    />
                                    <small className="text-muted">
                                        Each line will be treated as a separate raw data entry
                                    </small>
                                </div>

                                <h3>🔍 Parsed Data</h3>
                                <div className="mb-3">
                                    <label className="form-label">Parsed Data (JSON)</label>
                                    <textarea
                                        className="form-control"
                                        rows={15}
                                        placeholder="Enter parsed data as JSON"
                                        value={parsedDataText}
                                        onChange={(e) => setParsedDataText(e.target.value)}
                                        disabled={disabled}
                                    />
                                    <small className="text-muted">
                                        Must be valid JSON format
                                    </small>
                                </div>

                                <hr />
                                <div className="mb-3">
                                    Errors: {JSON.stringify(errors)}
                                </div>

                                <Button
                                    className="mb-3"
                                    type="submit"
                                    disabled={Object.keys(errors).length > 0 || isSubmitting || disabled}
                                >
                                    Submit
                                </Button>

                            </Form>
                        </>
                    )
                }}
            </Formik>
        </div>
    )
}